import Flex from "components/grid/Flex";
import { Typography } from "@material-ui/core";
import moment from "moment/moment";

const Date = ({ date, isNew, style }) => {
    return date && date.trim && date.trim() ? <Flex item grow={0} container alignItems={"center"} style={style}>
        <Typography style={{ color: "#b1b1b1", marginRight: 2 }}>{moment(date).format("MMM").substring(0,3)}</Typography>
        <Typography style={{ color: isNew ? "#007bff" : "black" }}>{moment(date).format("YYYY")}</Typography>
    </Flex> : <></>;
};

export default Date;
